import React, { ReactElement } from 'react'
import { Empty, Pagination, Spin, TableColumnType, TableProps } from 'antd'
import get from 'lodash/get'
import classNames from 'classnames'

export interface TableMobileColumnType<T> extends TableColumnType<T> {
  rowClassName?: string
  dataIndex?: any
}

export interface TableMobileProps<T> extends TableProps<T> {
  columns?: TableMobileColumnType<T>[]
}

const TableMobile: <T extends object = any>(
  props: TableMobileProps<T>,
  context?: any,
) => ReactElement<any, any> | null = ({ loading, dataSource, columns, className, pagination }) => {
  const renderItem = (item, index) => {
    return (
      <div key={item?.id} className={classNames('flex flex-col gap-3')}>
        {columns?.map((_item) => {
          const value = get(item, Array.isArray(_item?.dataIndex) ? _item?.dataIndex?.join('.') : _item?.dataIndex)

          const renderElement = _item?.render ? _item?.render(value, item, index) : value

          return (
            <div key={_item?.key} className={classNames('flex items-start gap-5 justify-between text-primary', _item?.rowClassName)}>
              {typeof _item?.title === 'string' ? (
                <p className="text-secondary text-[14px] leading-6">{_item?.title}</p>
              ) : (
                _item?.title
              )}
              {typeof renderElement === 'string' ? (
                <div className={classNames(_item?.className)}>{renderElement}</div>
              ) : (
                renderElement
              )}
            </div>
          )
        })}
      </div>
    )
  }

  if (loading) {
    return (
      <div className={classNames('min-h-[300px] flex justify-center items-center', className)}>
        <Spin size="large" />
      </div>
    )
  }

  if (!dataSource?.length)
    return (
      <div className={classNames('min-h-[300px] flex justify-center items-center', className)}>
        <Empty />
      </div>
    )

  return (
    <div className='flex flex-col gap-5'>
      <div className={classNames('min-h-[300px] flex flex-col gap-6', className)}>{dataSource?.map(renderItem)}</div>
      <Pagination className='self-end' {...pagination} />
    </div>
  )
}

export default TableMobile
